import { gql, useLazyQuery } from "@apollo/client";
import { useMemo, useState } from "react";
import useProcessData from "../../../CommonFunction/ProcessData";
import { LoadTable } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import Loading from "../../Components/Loading/Loading";
import useFetchTableData from "../../custom_hooks/useFetchTableData";

const queryfunction = (fields) => {
    const query = gql`
        query GetAlloelplUsers {
        getAlloelplUsers {
            Department
            Email
            Full_Name
            Is_Active
            Mobile
            UserName
            _id
            Unique_Id
            createdAt
            LR_Center
            updatedAt
        }
        }
            `;
    return query;
};

const OrionAppUsers = () => {
    const [formData, setFormData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const Key = "OrionAppUser";
    const config = useMemo(
        () => ({
            dataKey: "getAlloelplUsers",
            dateKeys: ["createdAt", "updatedAt"],
            deleteKeys: ["is_Audit", "__typename"],
        }),
        []
    );
    const [fetchUsersData, { loading: queryLoading, error, data }] = useLazyQuery(queryfunction([]), {
        fetchPolicy: "network-only",
        
        context: {
        headers: {
            "X-GraphQL-Server": "orion", // this triggers the orionLink
        },
        },
        onCompleted: () => {
            setIsLoading(false);
        },
        onError: () => {
            setIsLoading(false);
        },
    });
    const { loading, TableHeaders } = useFetchTableData(queryfunction, fetchUsersData, setIsLoading, Key);

    const { loading: processDataLoading } = useProcessData(data, setFormData, config, error);
    if (error?.message) {
        return (
            <>
                <HeaderDiv title="List Of Users" TableKey={Key} />
                <p className="DataNotAvailable">{error.message}</p>
            </>
        );
    }

    return (
        <div>
            <HeaderDiv title="List Of Orion App Users" TableKey={Key} />
            {isLoading ? (
                <Loading />
            ) : !formData?.length ? (
                <p className="DataNotAvailable">Data not Available</p>
            ) : (
                <>
                    {(queryLoading || loading) && <div className="loader-line-div" />}

                    <LoadTable title={Key} data={formData} loading={isLoading} error={error} TableHeaders={TableHeaders}
                    />
                </>
            )}
        </div>
    );
};

export default OrionAppUsers;
